/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChromeSlackVerifier_viewer = {
    readonly user: {
        readonly id: string;
        readonly emails: ReadonlyArray<string>;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $refType": "ChromeSlackVerifier_viewer";
};
export type ChromeSlackVerifier_viewer$data = ChromeSlackVerifier_viewer;
export type ChromeSlackVerifier_viewer$key = {
    readonly " $data"?: ChromeSlackVerifier_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ChromeSlackVerifier_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "ChromeSlackVerifier_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "emails",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1000000
                            }
                        ],
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '580da6ae71eac70945f904e4f9f30018';
export default node;
